var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _polygon, _polygon2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 381.11 371",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-1{fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M396,120.1c105.22,0,190.55,85.33,190.55,190.56q0,6.63-.46,13.15c-6.76-99.08-89.3-165.52-190.09-165.52s-183.33,66.44-190.1,165.52c-.29-4.34-.46-8.73-.46-13.15,0-105.23,85.33-190.56,190.56-190.56",
    transform: "translate(-205.43 -120.1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.63,490.18l-9.19.92s26.65-95.1,55.14-122.67,13.32-1.38,13.32-1.38-48.24,76.73-59.27,123.13",
    transform: "translate(-205.43 -120.1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.63,490.18l-9.19.92s26.65-95.1,55.14-122.67,13.32-1.38,13.32-1.38-48.24,76.73-59.27,123.13",
    transform: "translate(-205.43 -120.1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M326.76,275.05l-9.07,1.71s52.41,83.72,87.52,102.12,13.17-2.44,13.17-2.44-67.94-60-91.62-101.39",
    transform: "translate(-205.43 -120.1)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M326.76,275.05l-9.07,1.71s52.41,83.72,87.52,102.12,13.17-2.44,13.17-2.44-67.94-60-91.62-101.39",
    transform: "translate(-205.43 -120.1)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M465.21,275.05l9.07,1.71s-52.41,83.72-87.52,102.12-13.17-2.44-13.17-2.44,67.94-60,91.62-101.39",
    transform: "translate(-205.43 -120.1)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M461.34,490.18l9.19.92S443.88,396,415.39,368.43s-13.32-1.38-13.32-1.38,48.24,76.73,59.27,123.13",
    transform: "translate(-205.43 -120.1)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M378.12,282.38l-36.89-49.13,28.14-44.17,6.63,7.6-22.58,35.76,32,43.55Zm35.73,0,36.89-49.13L422.6,189.08l-6.63,7.6,22.58,35.76-32,43.55Z",
    transform: "translate(-205.43 -120.1)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M262.63,395l-6.5-6.57s66.33-28.57,110.16-33.83q3.29,3.48,6.56,6.66c-2,1.7-4.24,3.81-6.91,6.4-.13.12-.26.26-.38.39C335.41,373,289.71,382,262.63,395",
    transform: "translate(-205.43 -120.1)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M529.34,395l6.5-6.57s-66.33-28.57-110.16-33.83q-3.29,3.48-6.56,6.66c1.95,1.7,4.24,3.81,6.91,6.4.13.12.25.26.38.39C456.56,373,502.26,382,529.34,395",
    transform: "translate(-205.43 -120.1)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "207.9 148.11 173.21 148.11 155.86 178.15 173.21 208.2 207.9 208.2 225.24 178.15 207.9 148.11"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "175.68 277.82 205.43 277.82 221.88 323.95 190.55 371 159.22 323.95 175.68 277.82"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 184.61,
    y: 196.59,
    width: 11.87,
    height: 98.41
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/Logo1.04591fb058ccf43c58554f3aaa44ad06.svg";
export { ForwardRef as ReactComponent };